import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from "shards-react";
import { ISO8601_week_no } from "../../backend/common";
import { Loading } from "../common/Loader";
import { getPredictionStatus, makePredictions } from "../../backend/opinions";

export const FormBinefarPrediction = ({ refresh, date }) => {
  const [loading, setLoading] = useState(false);
  const [resultStatus, setResultStatus] = useState(null);
  const [result, setResult] = useState(null);

  let isPredictionActive = React.useRef(true);

  const fetchPredictionStatus = async () => {
    setLoading(true);
    while (isPredictionActive.current) {
      const { status } = await getPredictionStatus();
      if (status === "completed") {
        setResultStatus("success");
        setResult("Predicción completada");
        break;
      } else if (status === "running") {
        setLoading(true);
      } else if (!status || status === "failed") {
        setResultStatus("danger");
        setResult("Ha habido un error en la predicción");
        break;
      } else if (status !== "not started") {
        setResultStatus("warning");
        setResult(status);
        break;
      } else {
        break;
      }
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }
    isPredictionActive.current = false;
    setLoading(false);
    refresh();
  };

  useEffect(() => {
    fetchPredictionStatus();
    return () => {
      isPredictionActive.current = false;
    };
  }, []);

  const startPrediction = async () => {
    setLoading(true);
    setResult(null);
    setResultStatus(null);

    try {
      // Make the predictions
      const response = await makePredictions(date);
      if (!response) {
        throw new Error("Error al iniciar la predicción");
      }
      isPredictionActive.current = true;
      // Now wait for predictions to be made
      await fetchPredictionStatus();
    } catch (err) {
      setResultStatus("danger");
      setResult(err.message || "Ha habido un error");
    } finally {
      setLoading(false);
      refresh();
    }
  };

  return (
    <>
      <Card>
        <CardHeader className="p-3">
          <h4 className="m-0">Predicción</h4>
          <p className="m-0">Semana {ISO8601_week_no(new Date(date)) + 1}</p>
        </CardHeader>
        <CardBody className="p-3">
          <Button block size="lg" disabled={loading} onClick={startPrediction}>
            <Row>
              <Col>{loading ? "Prediciendo..." : "Iniciar Predicción"}</Col>
              {loading ? <Loading /> : null}
            </Row>
          </Button>
        </CardBody>
      </Card>
      {resultStatus !== null && (
        <Alert theme={resultStatus} className="mt-3">
          {result}
        </Alert>
      )}
    </>
  );
};
